import defineMessages from "../../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    scaling: {
        id: "tasks.rhythmSorting.scaling",
    },
});

export default messages;
